<script src="https://unpkg.com/html5-qrcode" type="text/javascript"></script>
<div id="reader"></div>